import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleLogin } from '@react-oauth/google';
import { useStore } from 'stores';
import { API_URL } from 'constants/config';
import { setSession } from 'utils/auth';

function Google() {
  const { t } = useTranslation();
  const login = useStore((state) => state.login);
  const closeDialog = useStore((state) => state.closeDialog);
  const [error, setError] = useState('');

  async function handleCredential({ credential }) {
    setError('');
    try {
      const res = await fetch(`${API_URL}/auth/google`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ id_token: credential }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.error === 'not_allowed') {
          setError(`${data.email} 不在允許名單內`);
        } else if (data.error === 'email_not_verified') {
          setError('Google 帳號未驗證');
        } else {
          setError('登入失敗');
        }
        return;
      }
      setSession(data.token, data.user);
      login(data.user.email);
      closeDialog();
      // Force a re-fetch of all the now-authorized data.
      window.location.reload();
    } catch (e) {
      setError('連線失敗');
    }
  }

  return (
    <div className="flex flex-col items-center space-y-3">
      <GoogleLogin
        onSuccess={handleCredential}
        onError={() => setError('Google 登入失敗')}
        useOneTap={false}
        text={t('SocialLogin.signUpWithGoogle')}
      />
      {error && <div className="text-red text-sm">{error}</div>}
    </div>
  );
}

export default Google;
